import { render } from "./EditColumnsPanel.vue?vue&type=template&id=911f3976&ts=true"
import script from "./EditColumnsPanel.vue?vue&type=script&lang=ts"
export * from "./EditColumnsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__